import { render } from "./ActionButton.vue?vue&type=template&id=1b151983&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=1b151983&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b151983"]])

export default __exports__